export const HR = ({ color = "#aaa" }) => <hr style={{ color }} />;
